import { useSetRecoilState } from 'recoil';
import { useEffect, useState } from 'react';
import alertState from '@/states/alertState';
import { isExpiredToken } from '@/utils/cognito';
import url from '@/utils/config';
import { ApiUrl, Constants } from '@/utils/constants';
import UpgradeContract from '@/components/templates/UpgradeContract';
import useGetUpgradeAcceptanceJudgemnent from '@/hooks/api/UseGetUpgradeAcceptanceJudgment';
import useGetUpgradeSTS from '@/hooks/api/UseGetUpgradeSTSInfo';
import useSetLoading from '@/hooks/useSetLoading';
import { judgeAcceptance } from '@/logic/UpgradeAcceptanceJudgement';
import { judgeLink } from '@/logic/UpgradeLink';
import { judgeSTS } from '@/logic/UpgradeSTS';

const ContractUpgrade = () => {
  // アラート
  const setAlert = useSetRecoilState(alertState);
  // ローディング
  const { startLoading, finishLoading } = useSetLoading();
  // 顧客管理.アップグレード可否判定API
  const { execute: AcceptanceJudgement } = useGetUpgradeAcceptanceJudgemnent();

  // 顧客管理.アップグレード可否判定APIの判定結果を取得
  const [upgradeacceptancejudgement, setAcceptanceJudgement] = useState<string>(
    Constants.UpgradesearchAcceptanceJudgement.UPGRADE
  );

  /**
   * アップグレード可否検索
   */
  const searchAcceptanceJudgement = async () => {
    const { data } = await AcceptanceJudgement();
    return data;
  };

  // アップグレード可否判定の結果によって画面表示を変更
  useEffect(() => {
    const searchUpgradesearchAcceptanceJudgement = async () => {
      try {
        startLoading(ApiUrl.Read.UPGRADE_ACCEPTANCE_JUDGEMENT);
        const data = await searchAcceptanceJudgement();
        if (data) {
          const result = judgeAcceptance(data.upgradable_g10_flg);
          setAcceptanceJudgement(result);
        }
      } catch (error: any) {
        const status = error.response?.status;
        // 契約対象外では 400/404 が返るケースがあるため、システムエラーにはしない。
        if (status === 400 || status === 404) {
          setAcceptanceJudgement(Constants.Upgrade.NOTUPGRADENG);
          return;
        }
        if (isExpiredToken(error)) {
          window.location.href = url('/login');
          sessionStorage.clear();
          return;
        }
        setAlert({
          isOpen: true,
          apiType: Constants.ApiType.API_GET,
        });
      } finally {
        finishLoading(ApiUrl.Read.UPGRADE_ACCEPTANCE_JUDGEMENT);
      }
    };
    searchUpgradesearchAcceptanceJudgement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // .顧客管理.10Gアップグレード紐づけSTS取得API
  const { execute: UpgradeSTSJudgement } = useGetUpgradeSTS();

  // .顧客管理.10Gアップグレード紐づけSTS取得APIの判定結果を取得
  const [upgradestsjudgement, setSTSJudgement] = useState<string>(Constants.UpgradesearchSTS.STS);
  const [message, setUpgradeISP] = useState<string>('');
  const [linkstate, setSTSLink] = useState<string>(Constants.UpgradelinkstateSTS.link);

  /**
   * 10Gアップグレード紐づけSTS検索
   */
  const searchSTSJudgement = async () => {
    const { data } = await UpgradeSTSJudgement();
    return data;
  };

  useEffect(() => {
    const searchUpgradeSTSJudgement = async () => {
      try {
        startLoading(ApiUrl.Read.UPGRADE_STS);
        const data = await searchSTSJudgement();
        if (data) {
          // 10Gアップグレード紐づけSTSの結果によって表示する画面を変更
          const result = judgeSTS(data.is_open_cnst);
          setSTSJudgement(result);
          // 10Gアップグレード紐づけSTSの結果によって遷移する画面を変更
          const resultlink = judgeLink(data.link_state);
          setSTSLink(resultlink);
          // 10GアップグレードISP契約番号を保持
          const resultispno = data.isp_cn_no;
          setUpgradeISP(resultispno);
        }
      } catch (error: any) {
        if (isExpiredToken(error)) {
          window.location.href = url('/login');
          sessionStorage.clear();
          return;
        }
        setAlert({
          isOpen: true,
          apiType: Constants.ApiType.API_GET,
        });
      } finally {
        finishLoading(ApiUrl.Read.UPGRADE_STS);
      }
    };
    searchUpgradeSTSJudgement();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <UpgradeContract
      UpgradeJudgeResult={upgradeacceptancejudgement}
      UpgradestsResult={upgradestsjudgement}
      Upgradeispno={message}
      UpgradeLinkstate={linkstate}
    />
  );
};
export default ContractUpgrade;
